import React from "react";

const Radio = (props) => (
  <div className="sideNavSection">
    <div className="feature">
      <h3>Dream Chimney Radio</h3>
      <a href="/radio" target="_blank" onClick="ga('send', 'event', 'radio', 'DC-promo', 'radio');">
        <img src="//www.dreamchimney.com/radio/dc_radio_logo.jpg" className="img-responsive center-block" alt="Dream Chimney Radio" />
      </a>
      <div id="app-now-playing"></div>

      <div className="featureTextFooter">
        <a href="/radio" target="_blank" onClick="ga('send', 'event', 'radio', 'DC-promo', 'radio');">
          Streaming 24/7 • Start listening &raquo;
        </a>
      </div>
    </div>
  </div>
);

export default Radio;
